var baseGet = require('./_baseGet');

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;



//////////////////
// WEBPACK FOOTER
// ./~/victory-cursor-container/~/lodash/_basePropertyDeep.js
// module id = ./node_modules/victory-cursor-container/node_modules/lodash/_basePropertyDeep.js
// module chunks = 1